import React from 'react';
import './styles.css';
import { MessageElement, BupSpinner } from '@BUP/components';
import { useTranslation } from 'react-i18next';

const MessagesList = ({
  title,
  titleDark,
  titleIcon,
  messages,
  isLoading,
  error,
  handleSetMessageState,
}) => {
  const [t] = useTranslation();
  return (
    <div className="modebup-inbox-messages-list-container">
      <div
        className="title-wrapper"
        style={titleDark ? { backgroundColor: '#767676' } : {}}
      >
        {titleIcon
          ? React.cloneElement(titleIcon, {
              className: `${titleIcon?.props?.className} title-icon`,
            })
          : null}
        {title || 'Sin titulo'}
      </div>
      {isLoading ? (
        <div className="modebup-inbox-contents-wrapper">
          <BupSpinner size="medium" />
        </div>
      ) : error ? (
        <div className="modebup-inbox-contents-wrapper">
          <h3>{t('pages.modeBup.inbox.MessagesListComponent.errorText')}</h3>
        </div>
      ) : messages && messages.length ? (
        <div className="modebup-inbox-messages-wrapper">
          {messages.map((message) => (
            <MessageElement
              key={`modebup-inbox-message-${message.id}`}
              message={message}
              handleSetMessageState={handleSetMessageState}
            />
          ))}
        </div>
      ) : (
        <div className="modebup-inbox-contents-wrapper">
          <h3>
            {t('pages.modeBup.inbox.MessagesListComponent.noMessageText')}
          </h3>
        </div>
      )}
    </div>
  );
};

export default MessagesList;
